import { render, staticRenderFns } from "./equipment8.vue?vue&type=template&id=2f72ae2a&scoped=true"
import script from "./equipment8.vue?vue&type=script&lang=js"
export * from "./equipment8.vue?vue&type=script&lang=js"
import style0 from "./equipment8.vue?vue&type=style&index=0&id=2f72ae2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f72ae2a",
  null
  
)

export default component.exports